var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["warningToast"]: () => __WEBPACK_EXTERNAL_MODULE__canopytax_toast_service_59ea07bb__.warningToast });